<div [formGroup]="group">
  <app-formelementinputlabel [config]="config" [group]="group"></app-formelementinputlabel>
  <app-form-timepicker-timespan [group]="group" [config]="config" [formControlName]="config.ClientId" #formInput></app-form-timepicker-timespan>
  <app-formelementinputdescription [config]="config" [group]="group"></app-formelementinputdescription>
  <app-formelementinput-validationmessages [config]="config" [group]="group"></app-formelementinput-validationmessages>
</div>
